
export type GetStreamingInfo200SupportedDevicesItem = typeof GetStreamingInfo200SupportedDevicesItem[keyof typeof GetStreamingInfo200SupportedDevicesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStreamingInfo200SupportedDevicesItem = {
  browser: 'browser',
  mobile: 'mobile',
  smarttv: 'smarttv',
} as const;
